<template>
    <div class="module">
        <div class="skeleton card row">
            <div class="content col pb-0">
                <div :style="{ height: customHeight + 'em' }"></div>
            </div>
            <div class="content d-flex col py-0">
                <div
                    class="box"
                    :style="{
                        width: customWidth + 'px',
                        height: customHeight + 'em'
                    }"
                ></div>
                <div
                    class="box"
                    :style="{
                        width: customWidth + 'px',
                        height: customHeight + 'em'
                    }"
                ></div>
                <div
                    class="box"
                    :style="{
                        width: customWidth + 'px',
                        height: customHeight + 'em'
                    }"
                ></div>
            </div>

            <div class="content col pb-0">
                <div :style="{ height: customHeight + 'em' }"></div>
            </div>
            <div class="content d-flex col py-0">
                <div
                    class="box"
                    :style="{
                        width: customWidth + 'px',
                        height: customHeight + 'em'
                    }"
                ></div>
                <div
                    class="box"
                    :style="{
                        width: customWidth + 'px',
                        height: customHeight + 'em'
                    }"
                ></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        customWidth: {
            type: Number,
            default: 120
        },
        customHeight: {
            type: Number,
            default: 4
        }
    }
};
</script>

<style scoped>
.skeleton.card .content div.box {
    margin-right: 10px;
}
</style>
